import { __decorate } from "tslib";
import Component from 'vue-class-component';
import SimpleCrud from '@/components/SimpleCrud.vue';
import Vue from 'vue';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { INPUT_TYPES } from '@/constants/InputTypes';
import { LESSON_TYPES } from '@/constants/LessonTypes';
import { getLastConcludedWorkDate } from '@/utils/effectiveDateValidation';
import moment from 'moment';
let Prices = class Prices extends Vue {
    lastConcludedDate = null;
    title = 'Ceny';
    storeModule = 'pricing';
    formAddTitle = 'Nová cena';
    formEditTitle = 'Upravit cenu';
    headers = [
        {
            text: 'Typ výuky',
            value: 'data.lessonType',
            rules: [VALIDATION_RULES.REQUIRED],
            type: INPUT_TYPES.SELECT,
            selectItems: LESSON_TYPES,
            selectValue: 'id',
            selectText: 'title',
        },
        {
            text: 'Počet hodin',
            value: 'data.hourCount',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.POSITIVE_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
        },
        {
            text: 'Počet studentů',
            value: 'data.studentCount',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.POSITIVE_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
        },
        {
            text: 'Cena',
            value: 'data.price',
            rules: [
                VALIDATION_RULES.REQUIRED,
                VALIDATION_RULES.UNSIGNED_NUMBER,
            ],
            type: INPUT_TYPES.NUMBER,
            customPrint: value => value + ',- Kč',
        },
        {
            text: 'Platnost od',
            value: 'data.effectiveDate',
            rules: [VALIDATION_RULES.REQUIRED, VALIDATION_RULES.VALID_DATE],
            type: INPUT_TYPES.DATE,
            customPrint: (value) => {
                if (!value)
                    return '';
                const m = moment(value);
                return m.isValid() ? m.format('DD.MM.YYYY') : '';
            },
        },
        {
            text: '',
            value: 'actions',
            rules: [],
            type: '',
            sortable: false,
            notEditable: true,
        },
    ];
    defaultItem = {
        id: 'new-pricing',
        data: {
            lessonType: '',
            price: 0,
            hourCount: 1,
            studentCount: 1,
            effectiveDate: moment().format('YYYY-MM-DD'),
            deletedAt: null,
        },
    };
    get userLoggedIn() {
        return this.$store.getters['user/isLoggedIn'];
    }
    async mounted() {
        this.lastConcludedDate = await getLastConcludedWorkDate();
    }
    /**
     * Determines if a pricing record can be edited.
     * Records with effectiveDate on or before the last concluded work date are immutable.
     * Legacy records without effectiveDate are treated as epoch date (1970-01-01) and are read-only.
     *
     * @param item - The pricing record to check
     * @returns true if the item can be edited, false otherwise
     */
    canEditItem(item) {
        if (!this.lastConcludedDate) {
            // No concluded work exists, all items can be edited
            return true;
        }
        // Treat missing effectiveDate as epoch (1970-01-01) - legacy data is read-only
        const effectiveDate = item.data.effectiveDate || '1970-01-01';
        // Can only edit if effectiveDate is strictly AFTER last concluded date
        return effectiveDate > this.lastConcludedDate;
    }
    /**
     * Determines if a pricing record is superseded by another record with the same criteria
     * but a newer effectiveDate that is already in effect (effectiveDate <= today).
     *
     * @param item - The pricing record to check
     * @returns true if the item is superseded, false otherwise
     */
    isPricingSuperseded(item) {
        if (!item.data?.effectiveDate)
            return false;
        const today = moment().format('YYYY-MM-DD');
        // Find if there's another active (non-deleted) pricing with same criteria and newer effectiveDate
        const items = this.$store.getters['pricing/all'];
        return items.some((other) => {
            if (other.id === item.id)
                return false;
            if (other.data?.deletedAt)
                return false;
            if (other.data?.lessonType !== item.data?.lessonType)
                return false;
            if (other.data?.hourCount !== item.data?.hourCount)
                return false;
            if (other.data?.studentCount !== item.data?.studentCount)
                return false;
            const otherDate = other.data?.effectiveDate || '1970-01-01';
            const itemDate = item.data?.effectiveDate || '1970-01-01';
            // Other must be newer AND still valid (effectiveDate <= today)
            return otherDate > itemDate && otherDate <= today;
        });
    }
};
Prices = __decorate([
    Component({
        components: {
            SimpleCrud,
        },
    })
], Prices);
export default Prices;
